import { lazy, Suspense } from "react";
import { createBrowserRouter, Outlet } from "react-router-dom";

import { ConsentGate } from "./components/ConsentGate";
import { ShellWithTabs } from "./components/ShellWithTabs";
import { ProductListSkeleton } from "./components/ProductListSkeleton";

// Route-level code splitting — each page becomes its own chunk so the initial
// JS payload only loads the landing page (and its deps).
const HomePage = lazy(() => import("./pages/HomePage").then((m) => ({ default: m.HomePage })));
const SearchPage = lazy(() => import("./pages/SearchPage").then((m) => ({ default: m.SearchPage })));
const DetailPage = lazy(() => import("./pages/DetailPage").then((m) => ({ default: m.DetailPage })));
const FavoritesPage = lazy(() =>
  import("./pages/FavoritesPage").then((m) => ({ default: m.FavoritesPage })),
);
const MePage = lazy(() => import("./pages/MePage").then((m) => ({ default: m.MePage })));
const CategoryPage = lazy(() =>
  import("./pages/CategoryPage").then((m) => ({ default: m.CategoryPage })),
);
const TopDealsPage = lazy(() =>
  import("./pages/TopDealsPage").then((m) => ({ default: m.TopDealsPage })),
);
const HistoryPage = lazy(() =>
  import("./pages/HistoryPage").then((m) => ({ default: m.HistoryPage })),
);
const BrandPage = lazy(() => import("./pages/BrandPage").then((m) => ({ default: m.BrandPage })));
const BrandsIndexPage = lazy(() =>
  import("./pages/BrandsIndexPage").then((m) => ({ default: m.BrandsIndexPage })),
);
const NotFoundPage = lazy(() =>
  import("./pages/NotFoundPage").then((m) => ({ default: m.NotFoundPage })),
);
const NotificationsPage = lazy(() =>
  import("./pages/NotificationsPage").then((m) => ({ default: m.NotificationsPage })),
);
const PrivacyPolicyPage = lazy(() =>
  import("./pages/PrivacyPolicyPage").then((m) => ({ default: m.PrivacyPolicyPage })),
);
const TermsOfServicePage = lazy(() =>
  import("./pages/TermsOfServicePage").then((m) => ({ default: m.TermsOfServicePage })),
);

function PageFallback() {
  return <ProductListSkeleton rows={3} />;
}

function LazyOutlet() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Outlet />
    </Suspense>
  );
}

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  {
    element: (
      <ShellWithTabs>
        <ConsentGate>
          <LazyOutlet />
        </ConsentGate>
      </ShellWithTabs>
    ),
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/top-deals", element: <TopDealsPage /> },
      { path: "/brands", element: <BrandsIndexPage /> },
      { path: "/favorites", element: <FavoritesPage /> },
      { path: "/me", element: <MePage /> },
    ],
  },
  // Stack pages (no bottom tabs) — wrap each in Suspense since they don't
  // share the ShellWithTabs Outlet.
  {
    element: <LazyOutlet />,
    children: [
      { path: "/search", element: <SearchPage /> },
      { path: "/product/:id", element: <DetailPage /> },
      { path: "/brand/:id", element: <BrandPage /> },
      { path: "/category/:id", element: <CategoryPage /> },
      { path: "/history", element: <HistoryPage /> },
      { path: "/notifications", element: <NotificationsPage /> },
      { path: "/legal/privacy", element: <PrivacyPolicyPage /> },
      { path: "/legal/terms", element: <TermsOfServicePage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
